import axios from "../../axios.js";
const fetchTasks = ({ commit }, data) => {
  const filter_param = data.filter_param
    ? `filter_param=${data.filter_param}&`
    : "";
  const on_page = data.on_page ? `on_page=${data.on_page}&` : "";
  const page_number = data.page_number
    ? `page_number=${data.page_number}&`
    : "";
  const status = data.status ? `status=${data.status}&` : "";
  const own = data.own ? `own=${data.own}&` : "";
  const category = data.category ? `category=${data.category}&` : "";
  const priority = data.priority ? `priority=${data.priority}&` : "";
  const url = `api/adminTask?${status}${on_page}${page_number}${filter_param}${own}${category}${priority}`;
  axios
    .get(url)
    .then((response) => {
      commit("SET_TASKS", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const fetchTodoTasks = async ({ commit }, data) => {
  const filter_param = data.filter_param
    ? `filter_param=${data.filter_param}&`
    : "";
  const on_page = data.on_page ? `on_page=${data.on_page}&` : "";
  const page_number = data.page_number
    ? `page_number=${data.page_number}&`
    : "";
  const status = `status=TODO&`;
  const own = data.own ? `own=${data.own}&` : "";
  const category = data.category ? `category=${data.category}&` : "";
  const priority = data.priority ? `priority=${data.priority}&` : "";
  const today = data.today ? `today=${data.today}&` : "";
  const future = data.future ? `future=${data.future}&` : "";
  const old = data.old ? `old=${data.old}&` : "";
  const admin_id = data.admin_id ? `admin_id=${data.admin_id}&` : "";
  const url = `api/adminTask?${status}${on_page}${page_number}${filter_param}${own}${category}${priority}${today}${future}${old}${admin_id}`;
  await axios
    .get(url)
    .then((response) => {
      commit("SET_TODO_TASKS", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const fetchInprogressTasks = async ({ commit }, data) => {
  const filter_param = data.filter_param
    ? `filter_param=${data.filter_param}&`
    : "";
  const on_page = data.on_page ? `on_page=${data.on_page}&` : "";
  const page_number = data.page_number
    ? `page_number=${data.page_number}&`
    : "";
  const status = `status=IN_PROGRESS&`;
  const own = data.own ? `own=${data.own}&` : "";
  const category = data.category ? `category=${data.category}&` : "";
  const priority = data.priority ? `priority=${data.priority}&` : "";
  const today = data.today ? `today=${data.today}&` : "";
  const future = data.future ? `future=${data.future}&` : "";
  const old = data.old ? `old=${data.old}&` : "";
  const admin_id = data.admin_id ? `admin_id=${data.admin_id}&` : "";
  const url = `api/adminTask?${status}${on_page}${page_number}${filter_param}${own}${category}${priority}${today}${future}${old}${admin_id}`;
  await axios
    .get(url)
    .then((response) => {
      commit("SET_INPROGRESS_TASKS", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const fetchOwnTasks = async ({ commit }, data) => {
  const filter_param = data.filter_param
    ? `filter_param=${data.filter_param}&`
    : "";
  const on_page = data.on_page ? `on_page=${data.on_page}&` : "";
  const page_number = data.page_number
    ? `page_number=${data.page_number}&`
    : "";
  const status = `status=IN_PROGRESS&`;
  const own = data.own ? `own=${data.own}&` : "";
  const category = data.category ? `category=${data.category}&` : "";
  const priority = data.priority ? `priority=${data.priority}&` : "";
  const today = data.today ? `today=${data.today}&` : "";
  const future = data.future ? `future=${data.future}&` : "";
  const old = data.old ? `old=${data.old}&` : "";
  const admin_id = data.admin_id ? `admin_id=${data.admin_id}&` : "";
  const url = `api/adminTask?${status}${on_page}${page_number}${filter_param}${own}${category}${priority}${today}${future}${old}${admin_id}`;
  await axios
    .get(url)
    .then((response) => {
      commit("SET_OWN_TASKS", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const fetchDoneTasks = async ({ commit }, data) => {
  const filter_param = data.filter_param
    ? `filter_param=${data.filter_param}&`
    : "";
  const own = data.own ? `own=${data.own}&` : "";
  const category = data.category ? `category=${data.category}&` : "";
  const priority = data.priority ? `priority=${data.priority}&` : "";
  const today = data.today ? `today=${data.today}&` : "";
  const future = data.future ? `future=${data.future}&` : "";
  const old = data.old ? `old=${data.old}&` : "";
  const on_page = data && data.on_page ? `on_page=${data.on_page}&` : "";
  const page_number =
    data && data.page_number ? `page_number=${data.page_number}&` : "";
  const status = "status=DONE&";
  const admin_id = data.admin_id ? `admin_id=${data.admin_id}&` : "";
  const url = `api/adminTask?${status}${on_page}${page_number}${filter_param}${own}${priority}${category}${today}${future}${old}${admin_id}`;
  await axios
    .get(url)
    .then((response) => {
      commit("SET_DONE_TASKS", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const fetchNumberOfTodoTasks = ({ commit }) => {
  axios
    .get(`/api/adminTask/todo/amount`)
    .then((response) => {
      commit("SET_NUMBER_OF_TODO_TASKS", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const setCounterTodoTasks = ({ commit }, counter) => {
  commit("SET_NUMBER_OF_TODO_TASKS", counter);
};

const fetchNotes = ({ commit }, data) => {
  const filter_param = data.search_param
    ? `filter_param=${data.search_param}&`
    : "";
  const on_page = data.on_page ? `on_page=${data.on_page}&` : "";
  const page_number = data.page_number
    ? `page_number=${data.page_number}&`
    : "";
  const status = data.filter_param ? `status=${data.filter_param}&` : "";
  const own = data.own ? `own=${data.own}&` : "";
  const category = data.second_filter_param
    ? `category=${data.second_filter_param}&`
    : "";
  const url = `api/profileNote?${status}${on_page}${page_number}${filter_param}${own}${category}`;
  axios
    .get(url)
    .then((response) => {
      commit("SET_NOTES", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

const fetchNumberOfNotes = ({ commit }) => {
  axios
    .get(`api/profileNote/todo/amount`)
    .then((response) => {
      commit("SET_NUMBER_OF_PROFILE_NOTES", response.data);
    })
    .catch((err) => {
      console.log(err);
    });
};

export default {
  fetchNotes,
  fetchTasks,
  fetchNumberOfTodoTasks,
  fetchNumberOfNotes,
  fetchDoneTasks,
  fetchTodoTasks,
  fetchInprogressTasks,
  fetchOwnTasks,
  setCounterTodoTasks,
};
